export default __webpack_public_path__ + "static/media/ic-close-copy.f27554cc.svg";